import {
  IFromIMDXFrontMatterListToPostList,
  IFromIMDXFrontMatterToPost,
} from "../../domain/mappers";
import { Post } from "../../domain/models/Post";
import {
  IMDXManager,
  IPostFrontMatter,
  MDX_MANAGER_FILE_TYPE,
} from "../../domain/repositories";
import { IAuthorRepository } from "../../domain/repositories/AuthorRepository";
import { ICategoryRepository } from "../../domain/repositories/CategoryRepository";

import {
  IGetPostParams,
  IGetPostsPrams,
  IPostRepository,
  IPostRepositoryParams,
} from "../../domain/repositories/PostRepository";

export class PostRepository implements IPostRepository {
  private _authorRepository: IAuthorRepository;
  private _categoryRepository: ICategoryRepository;
  private _mdxManager: IMDXManager;
  private _fromIMDXFrontMatterListToPostList: IFromIMDXFrontMatterListToPostList;
  private _fromIMDXFrontMatterToPost: IFromIMDXFrontMatterToPost;

  constructor({
    authorRepository,
    categoryRepository,
    fromIMDXFrontMatterListToPostList,
    fromIMDXFrontMatterToPost,
    mdxManager,
  }: IPostRepositoryParams) {
    this._authorRepository = authorRepository;
    this._categoryRepository = categoryRepository;
    this._fromIMDXFrontMatterListToPostList = fromIMDXFrontMatterListToPostList;
    this._fromIMDXFrontMatterToPost = fromIMDXFrontMatterToPost;
    this._mdxManager = mdxManager;
  }

  private getFileType = ({ isDraft = false }) => {
    if (isDraft) {
      return MDX_MANAGER_FILE_TYPE.DRAFTS;
    }

    return MDX_MANAGER_FILE_TYPE.POSTS;
  };

  // TODO: Implement that
  getDrafts = async ({ filters }: IGetPostsPrams) => {
    // TODO: MAP drafts MDX to DTO
    const drafts = await this.getPosts({
      filters: {
        drafts: true,
        ...filters,
      },
    });

    return drafts;
  };

  getDraftBySlug = async (slug: string) => {
    const draft = await this.getPostBySlug({ slug, isDraft: true });
    return draft;
  };

  getPosts = async ({ filters }: IGetPostsPrams) => {
    const isDraft = Boolean(filters?.drafts);
    const fileType = this.getFileType({ isDraft });

    const authors = await this._authorRepository.getAuthors();
    const categories = await this._categoryRepository.getCategories();
    const files: IPostFrontMatter[] = await this._mdxManager.getFiles({
      type: fileType,
    });

    const posts = this._fromIMDXFrontMatterListToPostList.map(
      files,
      authors,
      categories,
      isDraft
    );

    const postsOrderedByCreationDate = posts.sort((postA, postB) => {
      if (postA.meta.createdAt > postB.meta.createdAt) return -1;
      else if (postA.meta.createdAt < postB.meta.createdAt) return 1;
      else return 0;
    });

    if (filters?.categorySlug) {
      return postsOrderedByCreationDate.filter(
        (posts) => posts.category.slug === filters.categorySlug
      );
    }

    return postsOrderedByCreationDate;
  };

  getPostBySlug = async ({ slug, isDraft = false }: IGetPostParams) => {
    const fileType = this.getFileType({ isDraft });

    const file: IPostFrontMatter =
      await this._mdxManager.getFile<IPostFrontMatter>({
        type: fileType,
        slug,
      });

    const author = await this._authorRepository.getAurhorBySlug(file.author);
    const category = await this._categoryRepository.getCategoryBySlug(
      file.category
    );
    const post = this._fromIMDXFrontMatterToPost.map(
      file,
      [author],
      [category],
      isDraft
    );
    const postWithSerializedContent = this._mdxManager.serializeFile<Post>({
      file: post,
    });

    return postWithSerializedContent;
  };
}
